<template lang="pug">
.main-wrapper
  .top-wrapper
    Navbar
    .error(v-if="!ot && statusRequest") Orden No encontrada
    .container.flex-col.gap-1(v-if="ot")
      .flex-row.gap-2
        .label-ot Seguimiento OT:
        .label-ot.text-ot {{ot.ot}}

      //- Alert para pago de abono (solo en estado Cotización enviada)
      .alert-pago-abono(v-if="mostrarAlertPago")
        .d-flex.align-items-center.justify-content-between
          .d-flex.align-items-center
            span.mr-2 💳
            span {{ mensajeAlertPago }}
          b-button.btn-ver-pagos(@click="irAPestaniaPagos" size="sm") Ver pagos

      //- Alert para pago restante (solo cuando el equipo está listo)
      .alert-pago-restante(v-if="mostrarAlertPagoRestante")
        .d-flex.align-items-center.justify-content-between
          .d-flex.align-items-center
            span.mr-2 ✅
            span {{ mensajeAlertPagoRestante }}
          b-button.btn-ver-pagos(@click="irAPestaniaPagos" size="sm") Ver pagos

      b-row
        b-col(md="6" cols="12").mb-4.mb-md-0
          b-card.shadow-sm
            .card-contents.pb-4.pb-md-0
              h3.subtitle.mb-4.mb-md-2 Estado actual de la reparación

              .estado.mb-4(v-if="mostrarEstadoCliente")
                .status-text.mb-2(:style="getColor(ot.estado.estado)")
                  | {{ hasApproved3x3 ? 'Equipo con aprobación de cambio' : ot.estado.estado.nombre_cliente || ot.estado.estado.nombre }}
                .status-description
                  | {{ hasApproved3x3 ? '' : ot.estado.estado.descripcion_cliente }}

              b-progress.barra-progreso(v-if="mostrarEstadoCliente" :max="100" height="2rem" variant="samtek-yellow")
                b-progress-bar( :value="ot.estado.estado.porcentaje_cliente" )
                  div
                    span.h6.bar-text {{ hasApproved3x3 ? '100' : parseFloat(ot.estado.estado.porcentaje_cliente) }}
                    span.sign.bar-text %

              h3.subtitle Diagnóstico
              .flex-col.mt-3(v-if="ot.diagnostico_detail && ot.estado.estado.nombre !== 'Diagnosticado por revisar'")
                .flex-col
                  .label Informe
                  p {{ ot.diagnostico_detail.informe || '' }}
                .flex-col
                  .label Solución
                  p {{ ot.diagnostico_detail.solucion || '' }}
              .flex-col.align-items-center.text-center(v-else)
                b-img.blank-img.mb-4.mt-5.mt-md-3(:src="require('@/assets/img/diagnostic-blank.png')")
                span Tu equipo ha sido ingresado.
                span Tan pronto como tengamos su diagnostico podrás verlo en esta pantalla

        b-col(md="6" cols="12")
          b-card.shadow-sm
            .card-contents
              b-tabs(ref="tabsPagos" pills card justified lazy v-model="tabIndex")
                b-tab(title="Datos Equipo")
                  TabDeviceData(:ot="ot")
                b-tab(title="Historial")
                  StateHistory(:states="stateHistory")

                b-tab.tabs(title="Informes")
                  h3.subtitle.mb-3 Informes
                  .flex-col.gap-4
                    .flex-row.align-items-center.justify-content-between(v-if="ot.diagnostico && ot.informe_cliente_pdf")
                      .label.label-text Informe de Diagnóstico
                      b-btn(variant="samtek-yellow" @click="downloadReport(ot.ot)")
                        b-icon( icon="file-earmark-arrow-down-fill" )
                        strong.ml-2.download-pdf Descargar PDF
                    .flex-row.align-items-center.justify-content-between(v-if="pdfIngreso")
                      .label.label-text Orden de ingreso
                      b-btn(variant="samtek-yellow" @click="downloadEntryPDF")
                        b-icon( icon="file-earmark-arrow-down-fill" )
                        strong.ml-2.download-pdf Descargar PDF

                b-tab(title="Adjuntos")
                  h3.subtitle.mb-2 Adjuntos
                  .thumbnails
                    .thumbnail-item(v-for="file,index in files" :key="file.file_id")
                      b-icon.h3.images-icon(v-if="file.file_type === 'pdf'" icon="file-pdf")
                      b-icon.h3.images-icon(v-else-if="notAnImage(file.file_type)" icon="file-alt")
                      b-img(v-else-if="fileBlobUrls[index]" :src="fileBlobUrls[index]" thumbnail)
                      b-icon.h3.images-icon(v-else icon="images")
                  .flex-row.justify-content-end.mt-3.mr-3
                    b-btn.label.label-text(variant="samtek-yellow" @click="downloadAllImages" :disabled="downloadingAll") Descargar Todas
                b-tab(title="Pagos", v-if="esPresupuesto")
                  .repuestos-section(v-if="ovData")
                    h3.subtitle.mb-3 Repuestos y Mano de Obra
                    TabPaymentsTable(:productos="ovData.productos")

                    TabPaymentData(:ovData="ovData")

                    //- Resumen de Pagos (cuando hay información de OV Cliente)
                    .mt-4(v-if="ovDataCliente && ovDataCliente.estado")
                      b-card.payment-summary-card
                        h4.mb-3 Resumen de Pago
                        .summary-row
                          span Monto Total:
                          strong ${{ formatearPrecio(ovDataCliente.monto_total_final) }}
                        .summary-row(v-if="ovDataCliente.monto_abonado > 0")
                          span Monto Abonado:
                          strong.text-success ${{ formatearPrecio(ovDataCliente.monto_total_final - ovDataCliente.monto_restante) }}
                        .summary-row.total-row(v-if="ovDataCliente.monto_restante > 0")
                          span Monto Restante:
                          strong.text-primary ${{ formatearPrecio(ovDataCliente.monto_restante) }}

                    //- Botón de pago de ABONO (solo si puede pagar abono)
                    .mt-4(v-if="puedePagarAbono")
                      b-alert.mb-3(show variant="info")
                        strong Abono Requerido:
                        span  ${{ formatearPrecio(ovDataCliente.abono_requerido) }}
                        p.mb-0.mt-2.small Este monto debe ser pagado para continuar con la reparación de tu equipo.

                      //- Selector de tipo de documento
                      SelectorTipoDocumento(
                        @datos-actualizados="onDatosDocumentoAbonoActualizados"
                        :disabled="loadingPago || pagoEnProceso"
                      )

                      b-btn.label.label-text.mt-3(
                        variant="samtek-yellow"
                        @click="iniciarPagoAbono"
                        :disabled="loadingPago || pagoEnProceso || !puedePagarAbono || !datosDocumentoAbono.valido"
                        block
                      )
                        b-spinner(v-if="loadingPago" small class="mr-2")
                        span(v-if="loadingPago") Procesando...
                        span(v-else-if="pagoEnProceso") Pago en Proceso...
                        span(v-else) 💳 Pagar Abono Requerido (${{ formatearPrecio(ovDataCliente.abono_requerido) }})

                      //- Indicador cuando el popup está abierto
                      b-alert.mt-3(v-if="pagoEnProceso" show variant="warning")
                        .d-flex.align-items-center
                          b-spinner(small class="mr-2")
                          div
                            strong Ventana de pago abierta
                            p.mb-0.small Completa el pago en la ventana emergente. Si cerraste la ventana, el pago puede seguir procesándose.

                    //- Mensaje si ya pagó el ABONO
                    .mt-4(v-else-if="ovDataCliente && ovDataCliente.tiene_pago_abono_exitoso")
                      b-alert(show variant="success")
                        b-icon(icon="check-circle-fill" class="mr-2")
                        strong Abono Pagado
                        p.mb-0.mt-2 El abono requerido ya fue pagado exitosamente.
                        p.mb-0.mt-1.small(v-if="ovDataCliente.pago_abono_info && ovDataCliente.pago_abono_info.numero_boleta")
                          | Boleta N°: {{ ovDataCliente.pago_abono_info.numero_boleta }}

                    //- Botón de pago RESTANTE (solo si puede pagar restante)
                    .mt-4(v-if="puedePagarRestante")
                      b-alert.mb-3(show variant="primary")
                        strong ¡Tu equipo está listo!
                        p.mb-0.mt-2 Para finalizar y retirar tu equipo, completa el pago del monto restante.

                      //- Selector de tipo de documento
                      SelectorTipoDocumento(
                        @datos-actualizados="onDatosDocumentoRestanteActualizados"
                        :disabled="loadingPago || pagoEnProceso"
                      )

                      b-btn.label.label-text.mt-3(
                        variant="samtek-yellow"
                        @click="iniciarPagoRestante"
                        :disabled="loadingPago || pagoEnProceso || !datosDocumentoRestante.valido"
                        block
                        size="lg"
                      )
                        b-spinner(v-if="loadingPago" small class="mr-2")
                        span(v-if="loadingPago") Procesando...
                        span(v-else-if="pagoEnProceso") Pago en Proceso...
                        span(v-else) 💳 Pagar Monto Restante (${{ formatearPrecio(ovDataCliente.monto_restante) }})

                      //- Indicador cuando el popup está abierto
                      b-alert.mt-3(v-if="pagoEnProceso" show variant="warning")
                        .d-flex.align-items-center
                          b-spinner(small class="mr-2")
                          div
                            strong Ventana de pago abierta
                            p.mb-0.small Completa el pago en la ventana emergente. Si cerraste la ventana, el pago puede seguir procesándose.

                    //- Mensaje si OV está completamente pagada
                    .mt-4(v-else-if="ovDataCliente && ovDataCliente.tiene_pago_total_exitoso")
                      b-alert(show variant="success")
                        b-icon(icon="check-circle-fill" class="mr-2")
                        strong ¡Pago Completo!
                        p.mb-0.mt-2 Monto total pagado exitosamente.
                        p.mb-0.mt-1.small(v-if="ovDataCliente.pago_total_info && ovDataCliente.pago_total_info.numero_boleta")
                          | Boleta N°: {{ ovDataCliente.pago_total_info.numero_boleta }}

                    //- Mensaje informativo cuando no puede pagar restante (pero tiene abono pagado)
                    .mt-4(
                      v-else-if="ovDataCliente && ovDataCliente.estado_codigo === 'OPORTUNIDAD_LISTA' && !ovDataCliente.puede_pagar_restante && ovDataCliente.tiene_evidencia_abono"
                    )
                      b-alert(show variant="info")
                        b-icon(icon="info-circle" class="mr-2")
                        | Tu equipo está siendo preparado. El botón de pago del monto restante aparecerá cuando esté listo para retirar.

                    //- Mensaje de error si hay
                    b-alert.mt-3(v-if="errorPago" show variant="danger" dismissible @dismissed="errorPago = null")
                      strong Error:
                      span {{ errorPago }}
                //- Tab invisible para el layout
                b-tab(title="")
    .loader(v-if="loadingData")
      b-spinner(label='Cargando...' variant="primary")

  .bottom-wrapper
    .container
      hr.w-100.m-0
      span.footer-text © {{ currentYear }} Samtek | Servicio Técnico ASUS Autorizado en Chile.
  .floating-button-wrapper(v-if="ot")
    button.floating-button(@click="handleButtonClick")
      b-icon(:icon="showButtons ? 'x' : 'chat-right-text'" font-scale="1.5")
    .floating-buttons(v-if="showButtons")
      button.btn.btn-options(@click="openEmail")
        b-icon(icon="envelope"  font-scale="1.5")
      button.btn.btn-options(@click="openWhatsapp")
        b-icon(icon="whatsapp" font-scale="1.5" )
</template>

<script>
import moment from 'moment'
import JSZip from 'jszip'
import fileDownload from 'js-file-download'
import momentDurationFormatSetup from 'moment-duration-format'
import { mapGetters, mapActions } from 'vuex'
import pagosOVMixin from '@/mixins/pagosOV'
import Navbar from './Navbar/Navbar.vue'
import Status from '../Status.vue'
import TabDeviceData from './Subcomponents/TabDeviceData.vue'
import StateHistory from './Subcomponents/StateHistory.vue'
import TabPaymentsTable from './Subcomponents/TabPaymentsTable.vue'
import TabPaymentData from './Subcomponents/TabPaymentData.vue'
import SelectorTipoDocumento from '../../OV/SelectorTipoDocumento.vue'

momentDurationFormatSetup(moment)

export default {
  name: 'ClientOT',

  mixins: [pagosOVMixin],

  components: {
    Navbar,
    Status,
    TabDeviceData,
    StateHistory,
    TabPaymentsTable,
    TabPaymentData,
    SelectorTipoDocumento,
  },
  data() {
    return {
      pdfIngreso: null,
      stateHistory: [],
      fileBlobUrls: [],
      downloadingAll: false,
      showButtons: false,
      linkWhatsapp: null,
      linkEmail: null,
      loadingData: false,
      ovDataCliente: null,
      loadingOVData: false,
      pagoEnProceso: false,
      tabIndex: 0, // Índice del tab activo
      // Datos para pago con selección de tipo de documento
      datosDocumentoAbono: {
        tipo_documento: 'boleta',
        rut_contribuyente: null,
        valido: true,
      },
      datosDocumentoRestante: {
        tipo_documento: 'boleta',
        rut_contribuyente: null,
        valido: true,
      },
    }
  },
  async created() {
    const OT = parseInt(this.$route.params.otId, 10)
    const { rut } = this.$route.params
    const resp = await this.getPdfIngreso(OT)
    this.loadingData = true
    if (resp.status === 200) {
      // imprimir pdf de respuesta
      const file = new Blob([resp.data], { type: 'application/pdf' })
      const fileURL = URL.createObjectURL(file)
      this.pdfIngreso = fileURL
    }
    try {
      const resDataOt = await this.getOTPublic({ otId: OT, rut })
      if (this.ot) {
        const res = await this.getOTHistoryPublic({ otId: OT, rut })
        if (res.status < 200 || res.status >= 300) {
          return this.$bvToast.toast('Error al cargar historial', {
            variant: 'danger',
          })
        }
        this.linkEmail = resDataOt.mail
        this.linkWhatsapp = resDataOt.whatsapp
        this.stateHistory = res.data

        await this.getFiles(this.ot.ot)
        this.files.forEach(async (item, idx) => {
          const payload = {
            fileName: item.name,
            fileType: item.file_type,
            fileId: item.file_id,
          }
          this.$set(this.fileBlobUrls, idx, await this.getFileUrl(payload))
        })

        // Cargar datos de la OV para el cliente (información de pago)
        await this.cargarDatosOVCliente()
      }
    } catch (error) {
      console.error('Error al cargar los datos de la OT:', error)
      return this.$bvToast.toast('Error al cargar los datos de la OT', {
        variant: 'danger',
      })
    } finally {
      this.loadingData = false
    }
  },
  computed: {
    ...mapGetters('OTStore', ['ot', 'files', 'statusRequest']),
    currentYear() {
      return new Date().getFullYear()
    },
    mostrarEstadoCliente() {
      return (
        this.ot &&
        this.ot.estado &&
        this.ot.estado.estado &&
        this.ot.estado.estado.mostrar_en_sitio_cliente !== false
      )
    },
    esPresupuesto() {
      // tipo_servicio = 4 es PRESUPUESTO
      // Puede venir como número o como objeto {id: 4, nombre: "Presupuesto"}
      if (!this.ot) return false

      const tipoServicio = this.ot.tipo_servicio
      if (typeof tipoServicio === 'number') {
        return tipoServicio === 4
      }
      if (typeof tipoServicio === 'object' && tipoServicio !== null) {
        return tipoServicio.id === 4
      }
      return false
    },
    hasApproved3x3() {
      return (
        this.ot &&
        this.ot.excepciones.filter(
          (e) => e.tipo === 'Aprobación de 3x3' && e.estado === 2
        ).length > 0
      )
    },
    puedePagarAbono() {
      // Verificar que ovDataCliente esté cargado y el método del mixin esté disponible
      if (!this.ovDataCliente) return false

      return (
        this.ovDataCliente.puede_pagar_abono === true &&
        this.ovDataCliente.requiere_abono === true &&
        this.ovDataCliente.abono_requerido > 0 &&
        this.ovDataCliente.monto_total_final > 0 && // No se paga si el total es 0 (Garantía)
        !this.ovDataCliente.tiene_pago_abono_exitoso
      )
    },
    puedePagarRestante() {
      // Verificar que ovDataCliente esté cargado
      if (!this.ovDataCliente) return false
      const informeRevisado = this.ot?.diagnostico_detail?.revisado === true

      return (
        this.ovDataCliente.puede_pagar_restante === true &&
        this.ovDataCliente.monto_restante > 0 &&
        this.ovDataCliente.monto_total_final > 0 && // No se paga si el total es 0 (Garantía)
        !this.ovDataCliente.tiene_pago_total_exitoso &&
        informeRevisado
      )
    },
    mostrarAlertPago() {
      // Mostrar alert solo si es presupuesto, está en estado "Cotización enviada" y requiere abono
      if (
        !this.ot ||
        !this.ot.estado ||
        !this.ot.estado.estado ||
        !this.esPresupuesto
      )
        return false

      const estadoNombre = this.ot.estado.estado.nombre || ''
      const esCotizacionEnviada =
        estadoNombre.toLowerCase().includes('cotización enviada') ||
        estadoNombre.toLowerCase().includes('cotizacion enviada')

      return esCotizacionEnviada && this.puedePagarAbono
    },
    mensajeAlertPago() {
      if (this.ovDataCliente?.monto_total_final === 0) {
        return 'Tu reparación está cubierta al 100% por Garantía. No es necesario realizar pagos.'
      }
      return 'Para continuar con la reparación, es necesario realizar el pago del abono requerido.'
    },
    mostrarAlertPagoRestante() {
      // Mostrar alert cuando la OV esté en oportunidad lista, el informe esté revisado y haya pago restante
      if (!this.ot || !this.ovDataCliente || !this.esPresupuesto) return false

      const informeRevisado = this.ot?.diagnostico_detail?.revisado === true
      const esOportunidadLista =
        this.ovDataCliente.estado === 'Oportunidad Lista'
      const esGarantia = this.ovDataCliente.monto_total_final === 0

      return (
        esOportunidadLista &&
        informeRevisado &&
        (this.puedePagarRestante || esGarantia)
      )
    },
    mensajeAlertPagoRestante() {
      if (this.ovDataCliente?.monto_total_final === 0) {
        return '¡Tu equipo está listo! Esta reparación fue cubierta al 100% por Garantía. Puedes proceder al retiro.'
      }
      return '¡Tu equipo está listo! Para finalizar y retirar tu equipo, es necesario completar el pago del monto restante.'
    },
    fechaIngreso: ({ ot }) => moment(ot.fecha_ingreso).format('DD - MM - YYYY'),
    guiaIngreso: ({ ot }) => ot.guia_despacho_ingreso,
    tiempoIngreso: ({ ot }) =>
      moment
        .duration(ot.tiempo_estados.hora_total, 'second')
        .format('D[d] H[h]'),
    items() {
      const files =
        this.files.map((f, index) => ({
          number: index + 1,
          name: f.name ? f.name.split('/').pop() : '-',
          file: f,
        })) || []

      return files
    },
    ovData() {
      if (!this.ot || !this.ot.datos_ov_asociada) {
        return null
      }

      const ov = this.ot.datos_ov_asociada

      // Combinar productos de detalle_venta
      const productos = Array.isArray(ov.detalle_venta)
        ? ov.detalle_venta.map((item) => {
            const totalConDescuento =
              item.precio_total - (item.monto_descuento || 0)
            return {
              codigo: item.parte?.part_number || '-',
              producto: item.parte?.description || '-',
              cantidad: item.cantidad || '-',
              precio_unitario: item.precio_unitario
                ? `$${item.precio_unitario.toLocaleString('es-CL', {
                    useGrouping: true,
                  })}`
                : '-',
              descuento: item.monto_descuento
                ? `-$${item.monto_descuento.toLocaleString('es-CL', {
                    useGrouping: true,
                  })}`
                : '-',
              precio_total: totalConDescuento
                ? `$${totalConDescuento.toLocaleString('es-CL', {
                    useGrouping: true,
                  })}`
                : '-',
            }
          })
        : []

      // Combinar servicios
      const servicios = Array.isArray(ov.servicios)
        ? ov.servicios.map((item) => {
            const totalConDescuento =
              item.precio_total - (item.monto_descuento || 0)
            return {
              codigo: item.id || '-',
              producto: item.servicio?.nombre || '-',
              cantidad: item.cantidad || '-',
              precio_unitario: item.precio
                ? `$${item.precio.toLocaleString('es-CL', {
                    useGrouping: true,
                  })}`
                : '-',
              descuento: item.monto_descuento
                ? `-$${item.monto_descuento.toLocaleString('es-CL', {
                    useGrouping: true,
                  })}`
                : '-',
              precio_total: totalConDescuento
                ? `$${totalConDescuento.toLocaleString('es-CL', {
                    useGrouping: true,
                  })}`
                : '-',
            }
          })
        : []

      const productos_y_servicios = [...productos, ...servicios]

      return {
        productos: productos_y_servicios,
        costo_envio: ov.costo_envio
          ? `$${ov.costo_envio.toLocaleString('es-CL', { useGrouping: true })}`
          : '$0',
        monto_descuento: ov.monto_descuento
          ? `$${ov.monto_descuento.toLocaleString('es-CL', {
              useGrouping: true,
            })}`
          : '$0',
        subtotal: ov.monto_total_neto
          ? `$${ov.monto_total_neto.toLocaleString('es-CL', {
              useGrouping: true,
            })}`
          : '$0',
        iva: ov.valor_iva
          ? `$${ov.valor_iva.toLocaleString('es-CL', { useGrouping: true })}`
          : '$0',
        total: ov.monto_total_final
          ? `$${ov.monto_total_final.toLocaleString('es-CL', {
              useGrouping: true,
            })}`
          : '$0',
        descuento: ov.monto_descuento
          ? `$${ov.monto_descuento.toLocaleString('es-CL', {
              useGrouping: true,
            })}`
          : '-',
        abono_requerido: ov.abono_requerido
          ? `$${ov.abono_requerido.toLocaleString('es-CL', {
              useGrouping: true,
            })}`
          : '-',
        monto_abonado: ov.monto_abonado
          ? `$${ov.monto_abonado.toLocaleString('es-CL', {
              useGrouping: true,
            })}`
          : '-',
      }
    },
  },
  methods: {
    ...mapActions('OTStore', [
      'getOTPublic',
      'downloadReport',
      'getFiles',
      'downloadFile',
      'getPdfIngreso',
      'getOTHistoryPublic',
      'getFileUrl',
    ]),

    /**
     * Cargar datos de la OV del cliente (información de pago)
     */
    async cargarDatosOVCliente() {
      if (!this.ot || !this.$route.params.rut) return

      this.loadingOVData = true
      try {
        const result = await this.obtenerOVCliente(
          this.ot.ot,
          this.$route.params.rut
        )

        if (result.success) {
          this.ovDataCliente = result.data
          console.log('Datos OV cliente cargados:', this.ovDataCliente)
        } else {
          console.warn('No se pudieron cargar datos de OV:', result.error)
        }
      } catch (error) {
        console.error('Error al cargar datos OV cliente:', error)
      } finally {
        this.loadingOVData = false
      }
    },

    /**
     * Iniciar proceso de pago de ABONO
     */
    async iniciarPagoAbono() {
      if (this.loadingPago || this.pagoEnProceso) return

      // Validar que los datos del documento sean válidos
      if (!this.datosDocumentoAbono.valido) {
        this.$bvToast.toast(
          'Por favor valida el RUT del contribuyente antes de continuar',
          {
            title: 'Validación requerida',
            variant: 'warning',
            solid: true,
            autoHideDelay: 5000,
          }
        )
        return
      }

      const { ot } = this.ot
      const { rut } = this.$route.params

      const result = await this.iniciarPagoAbonoOV(
        ot,
        rut,
        this.datosDocumentoAbono.tipo_documento,
        this.datosDocumentoAbono.rut_contribuyente
      )

      if (result.success) {
        // Marcar pago en proceso
        this.pagoEnProceso = true

        // Redirigir a GetNet
        this.redirigirAGetNet(result.data.processUrl)
      } else {
        this.$bvToast.toast(result.error || 'Error al iniciar el pago', {
          title: 'Error',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
        })
      }
    },

    /**
     * Iniciar proceso de pago RESTANTE
     */
    async iniciarPagoRestante() {
      if (this.loadingPago || this.pagoEnProceso) return

      // Validar que los datos del documento sean válidos
      if (!this.datosDocumentoRestante.valido) {
        this.$bvToast.toast(
          'Por favor valida el RUT del contribuyente antes de continuar',
          {
            title: 'Validación requerida',
            variant: 'warning',
            solid: true,
            autoHideDelay: 5000,
          }
        )
        return
      }

      const { ot } = this.ot
      const { rut } = this.$route.params

      const result = await this.iniciarPagoRestanteOV(
        ot,
        rut,
        this.datosDocumentoRestante.tipo_documento,
        this.datosDocumentoRestante.rut_contribuyente
      )

      if (result.success) {
        console.log(
          'Pago restante iniciado exitosamente, redirigiendo a GetNet...'
        )

        // Marcar pago en proceso
        this.pagoEnProceso = true

        // Redirigir a GetNet
        this.redirigirAGetNet(result.data.processUrl)
      } else {
        console.error('Error al iniciar pago restante:', result.error)
        this.$bvToast.toast(
          result.error || 'Error al iniciar el pago restante',
          {
            title: 'Error',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          }
        )
      }
    },

    /**
     * Manejar cambios en selector de tipo de documento para abono
     */
    onDatosDocumentoAbonoActualizados(datos) {
      this.datosDocumentoAbono = datos
    },

    /**
     * Manejar cambios en selector de tipo de documento para pago restante
     */
    onDatosDocumentoRestanteActualizados(datos) {
      this.datosDocumentoRestante = datos
    },

    /**
     * Ir a la pestaña de Pagos
     */
    irAPestaniaPagos() {
      // Solo para presupuestos
      if (!this.esPresupuesto) return

      // El índice 4 corresponde a la pestaña "Pagos" (0: Datos Equipo, 1: Historial, 2: Informes, 3: Adjuntos, 4: Pagos)
      this.tabIndex = 4

      // Hacer scroll suave hacia los tabs
      this.$nextTick(() => {
        const tabsElement = this.$refs.tabsPagos?.$el
        if (tabsElement) {
          tabsElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
        }
      })
    },

    /**
     * Callback cuando se cierra el popup de GetNet
     */
    onPopupCerrado() {
      console.log('Popup cerrado, recuperando información del pago...')

      // Recuperar información del pago desde sessionStorage
      const pagoInfo = sessionStorage.getItem('pagoOVEnProceso')

      if (pagoInfo) {
        const { pago_id, ot, rut } = JSON.parse(pagoInfo)

        // Redirigir a resultado-pago con estado pendiente
        this.$router.push({
          path: `/ot/${ot}/${rut}/resultado-pago`,
          query: {
            estado: 'PENDIENTE',
            pago_id,
          },
        })
      } else {
        // Si no hay info, quedarse en la página actual y refrescar datos
        console.warn('No se encontró información del pago en sessionStorage')
        this.cargarDatosOVCliente()

        this.$bvToast.toast(
          'No pudimos confirmar el estado del pago. Por favor, recarga la página en unos momentos.',
          {
            title: 'Verificando Pago',
            variant: 'warning',
            solid: true,
            autoHideDelay: 5000,
          }
        )
      }
    },

    notAnImage(fileType) {
      return !['png', 'jpg', 'jpeg', 'gif'].includes(fileType)
    },
    toggleButtons() {
      this.showButtons = !this.showButtons // Alterna la visibilidad de los botones
    },
    openWhatsapp() {
      if (this.linkWhatsapp) {
        const whatsappUrl = `https://wa.me/${this.linkWhatsapp}`
        console.log('Whatsapp URL:', whatsappUrl)
        window.open(whatsappUrl, '_blank')
      } else {
        this.$bvToast.toast('Número de WhatsApp no disponible', {
          variant: 'danger',
        })
      }
    },
    openEmail() {
      if (this.linkEmail) {
        const mailtoLink = `mailto:${this.linkEmail}?subject=Consulta sobre la OT ${this.ot.ot}`
        window.location.href = mailtoLink // Esto abrirá la aplicación de correo con el mailto predefinido
      } else {
        this.$bvToast.toast('No hay correo disponible', { variant: 'danger' })
      }
    },
    handleButtonClick() {
      this.showButtons = !this.showButtons
    },
    downloadEntryPDF() {
      const link = document.createElement('a')
      link.href = this.pdfIngreso
      link.setAttribute(
        'download',
        `informe_ingreso_ot_${this.$route.params.otId}.pdf`
      )
      document.body.appendChild(link)
      link.click()
    },
    getColor(status) {
      if (status) {
        return `color: ${status.color_foreground}`
      }
    },

    async downloadAllImages() {
      this.downloadingAll = true
      const zip = new JSZip()
      const folder = zip.folder(`Adjuntos_OT_${this.ot.ot}`)
      await Promise.all(
        this.fileBlobUrls.map(async (url, index) => {
          if (!url) return
          const blob = await fetch(url).then((r) => r.blob())
          const fileName = this.files[index].name.split('/').pop()
          folder.file(fileName, blob)
        })
      )
      zip.generateAsync({ type: 'blob' }).then((content) => {
        fileDownload(content, `Adjuntos_OT_${this.ot.ot}.zip`)
      })
      this.downloadingAll = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../style/colors.scss';

.main-wrapper {
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
}

.bottom-wrapper .container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.error {
  text-align: center;
  font-size: 22px;
  color: #d22020;
}

.top-wrapper {
  display: flex;
  flex-direction: column;
}

.top-wrapper .container {
  font-size: 16px;
  color: #525252;

  @media (min-width: 768px) {
    > .row {
      flex-grow: 1;
      > div {
        height: 100%;
        > .card {
          border-radius: 15px;
          // padding-bottom: 40px;
        }
      }
    }
  }
}

.card-contents {
  @media (min-width: 768px) {
    height: min(calc(100vh - 260px), 640px);
    overflow-y: auto;
  }
}

::v-deep .card-body {
  @media (max-width: 767px) {
    padding: 10px;
  }
}

.label-ot {
  font-size: 28px;
  font-weight: 700;
  color: #525252;
}
.text-ot {
  color: $samtek-black;
}

/* Alert de pago de abono */
.alert-pago-abono {
  background-color: rgba(244, 194, 53, 0.2);
  border-radius: 10px;
  padding: 20px;
  margin-top: 16px;
  margin-bottom: 16px;

  span {
    color: #000;
    font-size: 16px;
    font-weight: 500;
  }

  .btn-ver-pagos {
    background-color: $samtek-yellow;
    color: $samtek-black;
    border: none;
    font-weight: 700;
    padding: 8px 20px;
    border-radius: 8px;
    transition: all 0.3s ease;

    &:hover {
      background-color: darken(#f4c235, 10%);
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }

    &:active {
      transform: translateY(0);
    }

    &:focus {
      box-shadow: 0 0 0 0.2rem rgba(244, 194, 53, 0.5);
    }
  }
}

/* Alert de pago restante */
.alert-pago-restante {
  background-color: rgba(244, 194, 53, 0.2);
  border-radius: 10px;
  padding: 20px;
  margin-top: 16px;
  margin-bottom: 16px;
  border-left: 4px solid #f4c235;

  span {
    color: #000;
    font-size: 16px;
    font-weight: 500;
  }

  .btn-ver-pagos {
    background-color: $samtek-yellow;
    color: $samtek-black;
    border: none;
    font-weight: 700;
    padding: 8px 20px;
    border-radius: 8px;
    transition: all 0.3s ease;

    &:hover {
      background-color: darken(#f4c235, 10%);
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }

    &:active {
      transform: translateY(0);
    }

    &:focus {
      box-shadow: 0 0 0 0.2rem rgba(244, 194, 53, 0.5);
    }
  }
}

.status-text {
  font-weight: bold;
  font-size: 40px;
  color: $samtek-black !important;
  text-align: center;
  @media (max-width: 767px) {
    font-size: 24px;
  }
}

.status-description {
  text-align: center;
}

.blank-img {
  width: 260px;
  @media (max-width: 767px) {
    width: 190px;
  }
}

.footer-text {
  margin: 12px 0;
}

::v-deep .nav-pills .nav-link {
  border-radius: 8px;
}

::v-deep .nav-pills .nav-link:not(.active) {
  color: #525252;
  font-weight: bold;
}

::v-deep .nav-pills .nav-link.active {
  color: $samtek-black;
  background-color: $samtek-yellow;
  font-weight: bold;
}

::v-deep .tabs > .card-header {
  padding: 5px;
  border-bottom: 0;
  background-color: #f8f9fe;
  @media (max-width: 767px) {
    background-color: transparent;
    overflow-x: auto;
    width: calc(100vw - 25px);
  }

  .card-header-pills {
    margin-left: 0;
    margin-right: 0;
    gap: 20px;
    scrollbar-width: thin;
    overflow-x: visible;

    > .nav-item {
      background-color: #f8f9fe;
      &:last-child {
        width: 0;
        margin-left: -25px;
        @media (min-width: 768px) {
          display: none;
        }
      }
    }
  }
}

::v-deep .tab-content > .tab-pane {
  padding-left: 0;
  padding-right: 0;
}

.thumbnails {
  display: flex;
  flex-wrap: wrap;
  // display: grid;
  // grid-template-columns: repeat(auto-fill, minmax(131px, 1fr));
  gap: 20px;
}

.thumbnail-item {
  width: 131px;
  height: 131px;
  border-radius: 10px;
  background-color: #f5f6fa;
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep {
  .subtitle {
    color: $samtek-black;
    font-weight: 700;
    font-size: 20px;
    margin: 0;

    @media (max-width: 767px) {
      font-size: 16px;
    }
  }

  .label {
    color: #525252;
    font-weight: bold;
    font-size: 16px;
  }
}

/* ---------------------------------------------------------------------------------------------- */

::v-deep .form-group label {
  color: #253590;
  font-weight: bold;
}

.change-text {
  color: var(--info);
  font-style: italic;
}

#ot-number {
  color: #5b73e8;
  font-size: 22px;
  font-weight: bold;
}
@media (min-width: 768px) {
  .orden,
  #ot-number {
    margin-left: 3rem;
  }
}
@media (max-width: 838px) {
  .orden {
    margin-top: 10px;
  }
}
.sub-title,
// .input-label {
//   width: 40%;
// }
.sub-title {
  color: #364599;
  font-weight: 700;
  font-size: 1em;
  margin-bottom: 0.3rem;
}
.details {
  display: flex;
  flex-direction: column;
  color: #74788d;
}
// .input-label {
//   color: #74788d;
//   font-weight: bold;
//   font-size: 1em;
//   margin-bottom: 0.3rem;
// }
.OT-form-card {
  margin-bottom: 1rem;
  box-shadow: 0 3px 6px 0 #00000029;
  opacity: 1;
  border-radius: 0.5rem;
  padding: 1rem;
  justify-content: space-between;
  background-color: white;
}
@media (min-width: 768px) {
  // .container {
  //   min-height: 100vh;
  // }
  .container-dos {
    gap: 2rem;
    margin-bottom: 2rem;
    max-width: 100%;
    margin-right: 4rem;
    margin-left: 3rem;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-auto-rows: minmax(60px, auto);
  }
  .cliente {
    margin: auto;
    width: 100%;
    // grid-row: 1/3;
    grid-column: 1/3;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .right-column {
    gap: 1rem;
    grid-column: 3/12;
    grid-row: 1/3;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-wrap: wrap;
    height: min-content;
  }
  @media (max-width: 1280px) {
    .cliente {
      grid-column: 1/4;
    }
    .right-column {
      grid-column: 4/12;
    }
  }
  .estado {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin: auto;
    width: 100%;
    padding: 5px 20px;
    text-align: center;
    color: $samtek-grey;
  }
  .right-column {
    .bar {
      height: 3rem;
      box-shadow: 1px 5px 15px 3px rgba(204, 204, 204, 1);
      opacity: 1;
      border: none;
      margin-bottom: 1rem;
      color: #5b73e8;
      font-size: 1rem;
    }
    .status-description {
      color: var(--info);
      font-size: 16px;
    }
    .display-data {
      margin: auto;
      font-size: 1rem;
      font-weight: 600;
      color: #74788d;
      text-align: center;
    }
  }
  .card-diagnostico,
  .card-adjuntos {
    flex-grow: 1;
    .text {
      min-height: 3rem;
    }
  }
  .card-adjuntos {
    grid-column: 1/12;
  }
}

.barra-progreso {
  background-color: #e9ecef;
  border: none;
  margin-bottom: 32px;
  @media (max-width: 767px) {
    margin-left: 10px;
    margin-right: 10px;
    .h6 {
      font-size: 12px;
    }
    .sign {
      font-size: 8px;
    }
  }
}
.bar-text {
  color: $samtek-black !important;
  font-weight: 700 !important;
  font-size: 14px !important;
}

hr {
  margin: 0 0 1rem;
}
.label-text {
  color: $samtek-black !important;
}
.donwload-pdf {
  color: $samtek-black;
  background-color: $samtek-yellow;
  font-weight: bold;
}
.images-icon {
  color: #f4c235 !important;
}
.floating-button-wrapper {
  position: fixed;
  bottom: 20px;
  right: 35px;
  z-index: 1000;
}

.floating-button {
  background-color: #fece2f;
  color: black;
  border: none;
  border-radius: 10%;
  width: 60px;
  height: 60px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 24px;
}
.floating-button:focus,
.btn-options:focus {
  outline: none;
}
.floating-buttons {
  position: absolute;
  bottom: 80px;
  right: 0px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.btn-options {
  background-color: #fece2f;
  color: black;
  border: none;
  width: 60px;
  height: 60px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
}

/* Estilos para la sección de repuestos */
.repuestos-section {
  padding: 20px 0;

  .data-label {
    width: 70%;
    font-size: 14px;
    font-weight: 700;
    text-align: left;
    color: #525252;
    margin: 0;
  }

  .data-info {
    width: 30%;
    font-size: 14px;
    font-weight: 400;
    color: #525252;
    text-align: left;
    margin: 0;
  }

  .resumen-valores {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    border-top: 1px solid #000;
    padding-top: 10px;
    width: 100%;
    max-width: 300px;
  }

  .valor {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 5px;

    &.border-top-valor {
      border-top: 1px solid #000;
      padding-top: 10px;
      margin-top: 5px;
    }
  }
}

/* Estilos para la tarjeta de resumen de pagos */
.payment-summary-card {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 20px;

  h4 {
    color: #525252;
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 15px;
  }

  .summary-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #dee2e6;
    font-size: 16px;

    span {
      color: #525252;
    }

    strong {
      font-size: 18px;
      font-weight: 700;
    }

    &:last-child {
      border-bottom: none;
    }

    &.total-row {
      margin-top: 10px;
      padding-top: 15px;
      border-top: 2px solid #525252;

      strong {
        font-size: 20px;
      }
    }
  }
}
</style>
